import { render, staticRenderFns } from "./KChart.vue?vue&type=template&id=14b79858&scoped=true"
import script from "./KChart.vue?vue&type=script&setup=true&lang=js"
export * from "./KChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./KChart.vue?vue&type=style&index=0&id=14b79858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b79858",
  null
  
)

export default component.exports